import { isPlatform } from '@ionic/core'
import { IonButton, IonButtons, IonContent, IonHeader, IonIcon, IonInput, IonItem, IonItemDivider, IonLabel, IonList, IonPage, IonSpinner, IonTitle, IonToolbar, useIonModal, useIonToast } from '@ionic/react'
import Lightning from 'assets/icons/Lightning'
import HelpModal from 'components/HelpModal/HelpModal'
import { AuthContext } from 'contexts/AuthContext'
import { chevronBackOutline, helpCircleOutline } from 'ionicons/icons'
import { useContext, useState } from 'react'
import { useHistory } from 'react-router'
import client from 'utils/Api'

const BTCPaySetup = () => {
    const { authState } = useContext(AuthContext)
    const [help, setHelp] = useState(null)
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [serverUrl, setServerUrl] = useState();
    const [storeId, setStoreId] = useState();
    const [apiKey, setApiKey] = useState();
    const [presentToast,] = useIonToast();
    const axiosClient = client(authState.token);

    const connect = async () => {
        setLoading(true)

        try {
            const res = await axiosClient.post('/account/btcpay', {
                provider: 'btcpay',
                server_url: serverUrl,
                store_id: storeId,
                api_key: apiKey
            })
            if (res.data?.account_id) {
                presentToast({
                    color: "dark",
                    duration: 3000,
                    position: "top",
                    message: "Successfully setup your LSP",
                    icon: Lightning,
                });
                history.push('/notifications', { direction: 'back' });
                // history.push('/account/welcome', {
                //   opennode_account_id: res.data.opennode_account_id
                // });
            }
        } catch (error) {
            presentToast({
                color: "danger",
                duration: 3000,
                position: "top",
                message: "Unable to connect to your node.  Please ensure your node info is correct.",
                icon: Lightning,
            });
        }
        setLoading(false);
    }

    const handleHelpModal = (s) => {
        setHelp(s);
        present({
            swipeToClose: true,
            cssClass: "rounded",
            showBackdrop: true,
            backdropDismiss: true,
            initialBreakpoint: isPlatform("desktop") ? undefined : 0.75,
            breakpoints: isPlatform("desktop") ? undefined : [0, 0.75],
        });
    }

    const handleDismiss = () => {
        dismiss();
    }

    const [present, dismiss] = useIonModal(HelpModal, {
        step: help,
        onDismiss: handleDismiss
    })

    return (
        <IonPage>
            <IonHeader className={'ion-no-border'}>
                <IonToolbar className={'transparent'}>
                    <IonButtons slot="start">
                        <IonButton
                            fill="clear"
                            onClick={() => history.goBack()}>
                            <IonIcon icon={chevronBackOutline} />
                        </IonButton>
                    </IonButtons>
                    <IonTitle>BTC Pay Server Setup</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <IonList>
                    <IonItemDivider>Server Info</IonItemDivider>

                    <IonItem>
                        <IonLabel position='stacked'>Server URL</IonLabel>
                        <IonInput type="text" name="server_url" placeholder='https://btcpay.example.com' value={serverUrl} onIonChange={(e) => setServerUrl(e.target.value)}></IonInput>
                    </IonItem>

                    <IonItem>
                        <IonLabel position='stacked'>Store ID</IonLabel>
                        <IonInput type="text" name="store_id" placeholder="Enter store id" value={storeId} onIonChange={(e) => setStoreId(e.target.value)}></IonInput>
                        <IonIcon slot="end" icon={helpCircleOutline} onClick={() => handleHelpModal(2)} />
                    </IonItem>

                    <IonItem>
                        <IonLabel position='stacked'>Invoice API Key</IonLabel>
                        <IonInput type="text" name="api_key" placeholder='Enter api key' value={apiKey} onIonChange={(e) => setApiKey(e.target.value)}></IonInput>
                        <IonIcon slot="end" icon={helpCircleOutline} onClick={() => handleHelpModal(3)} />
                    </IonItem>
                    <br />
                    <IonButton expand="block" style={{ margin: 15 }} onClick={() => connect()} disabled={!serverUrl || !storeId || !apiKey}>{loading ? <IonSpinner name="crescent" /> : "Connect"}</IonButton>

                </IonList>
            </IonContent>
        </IonPage>
    )
}

export default BTCPaySetup